import React from 'react';

export const Icon16PXCreditCard = (params: { fill: string; style?: React.CSSProperties }) => (
  <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg' style={params.style}>
    <path
      d='M25.6663 7.00008V21.0001C25.6663 21.6417 25.4379 22.1911 24.9809 22.648C24.524 23.1049 23.9747 23.3334 23.333 23.3334H4.66634C4.02467 23.3334 3.47537 23.1049 3.01842 22.648C2.56148 22.1911 2.33301 21.6417 2.33301 21.0001V7.00008C2.33301 6.35841 2.56148 5.80911 3.01842 5.35216C3.47537 4.89522 4.02467 4.66675 4.66634 4.66675H23.333C23.9747 4.66675 24.524 4.89522 24.9809 5.35216C25.4379 5.80911 25.6663 6.35841 25.6663 7.00008ZM4.66634 9.33341H23.333V7.00008H4.66634V9.33341ZM4.66634 14.0001V21.0001H23.333V14.0001H4.66634Z'
      fill={params.fill}
    />
  </svg>
);
